import React from 'react';
import PropTypes from 'prop-types';
import { withWidth } from '@material-ui/core';

import { Stepper as MuiStepper } from '@material-ui/core';

// Stepper will change to vertical orientation on mobile devices
// unless orientation is explicitly set to horizontal
const Stepper = ({ children, width, orientation, ...rest }) => {
  return (
    <MuiStepper
      orientation={!orientation && width === 'xs' ? 'vertical' : orientation}
      {...rest}
    >
      { children }
    </MuiStepper>
  )
}

Stepper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default withWidth()(Stepper);



// WEBPACK FOOTER //
// ./src/components/base/Stepper/Stepper.js